import * as api from '../api'
import { LANDING_PAGE_ROUTE } from 'core/constants'
import { getActiveLocale } from 'shared/country'
const stateSelector = state => state.wordpress || {}
const componentsSelector = createSelector(stateSelector, wordpress => wordpress.components || {})
export const componentSelector = name => createSelector(componentsSelector, components => components[name] || {})
export const entitySelector = name => createSelector(stateSelector, entities => entities[name] || {})
export const objectsOrKeysByKeysSelector = (entityName, keys = []) =>
    createSelector(entitySelector(entityName), selectedEntities => keys.map(key => selectedEntities[key] || key))

/* --- */

export const pendingName = (kind, id = '') => `${kind}${id}`
export const pendingSelector = kind =>
    createSelector(api.selectors.pendingSelector, pendingItems => pendingItems[pendingName(kind)] === true)
export const notPendingSelector = (kind, postIDs) =>
    createSelector(api.selectors.pendingSelector, pendingItems =>
        postIDs.map(id => (pendingItems[pendingName(kind, id)] === true ? false : id))
    )
export const formPendingSelector = createSelector(
    state => state.pending,
    pending => pending.submitForm
)
export const pendingFeedbackSelector = createSelector(api.selectors.pendingSelector, pending => ({
    pending: pending['sendFeedback'] === true,
    error: pending['sendFeedback'] instanceof Object ? pending['sendFeedback'] : false,
}))
/* --- */

export const languagesSelector = entitySelector('languages')

export const preferredLocaleSelector = createSelector(languagesSelector, languages => {
    const activeLocale = getActiveLocale(languages)
    const localeArray = activeLocale.split('-')
    return localeArray.slice(0, 1).concat(localeArray[1].toUpperCase()).join('_')
})

export const wordpressLanguageObjectSelector = createSelector(languagesSelector, languages =>
    Object.values(languages)
        .filter(language => language.current)
        .shift()
)
export const wordpressLanguageSelector = createSelector(
    wordpressLanguageObjectSelector,
    language => language && language.slug
)

/* --- */

const routeMapSelector = entitySelector('routes')
export const routesSelector = createSelector(routeMapSelector, routes => Object.values(routes))
export const fixedRoutesSelector = createSelector(routesSelector, routes => routes.filter(route => !route.custom))
export const customRoutesSelector = createSelector(routesSelector, routes => routes.filter(route => route.custom))
export const landingPageRouteSelector = createSelector(
    routesSelector,
    routes => routes.filter(route => route.role === LANDING_PAGE_ROUTE)[0]
)

/* --- */

export const metaSelector = entitySelector('meta')
export const subscriptionSelector = state => state.subscription || {}
export const hasReceivedConfigurationSelector = state => state.hasReceivedConfiguration
export const configurationPendingSelector = state => state.configurationPending
export const configurationErrorSelector = createSelector(api.selectors.pendingSelector, pending =>
    pending.configuration instanceof Error ? pending.configuration : ''
)

/* --- */

const externalMonthlyTicketSystemSelector = createSelector(componentSelector('header'), header => header.seasonTicket)
export const externalMonthlyTicketSystemUrlSelector = createSelector(externalMonthlyTicketSystemSelector, ext =>
    ext ? ext.url : undefined
)

const miscSelector = componentSelector('misc')
const paymentNoticeSelector = componentSelector('paymentNotice')
export const appStoreBadgeUrlSelector = createSelector(
    miscSelector,
    misc => misc.appStoreBadge && misc.appStoreBadge.url
)
export const googlePlayBadgeUrlSelector = createSelector(
    miscSelector,
    misc => misc.googlePlayStoreBadge && misc.googlePlayStoreBadge.url
)
export const acceptTermsLabelSelector = createSelector(miscSelector, misc => misc.acceptTermsAndConditions)
export const subscribeOffersLabelSelector = createSelector(miscSelector, misc => misc.subscribeToOffers)
export const subscribeNewsLabelSelector = createSelector(miscSelector, misc => misc.subscribeToNews)
export const signupTextblockUpSelector = createSelector(miscSelector, misc => misc.signupTextblockUp)
export const signupTextblockDownSelector = createSelector(miscSelector, misc => misc.signupTextblockDown)
export const cookiePolicyUrlSelector = createSelector(miscSelector, misc => misc.cookiePolicyUrl)

export const paymentNoticeRegionsSelector = createSelector(paymentNoticeSelector, p => p.columns)

export const airportsSelector = createSelector(stateSelector, wordpress => (wordpress ? wordpress.airports : []))

export const brandLogosSelector = createSelector(stateSelector, entities => entities?.themeSettings?.logos || null)

export const companyValueSelector = createSelector(miscSelector, misc => misc.companyValueDesc)
